//@ts-nocheck
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  HStack,
  Stack,
  Text,
} from "@chakra-ui/react";
import React from "react";
import Icon from "../../components/ui-elements/Icon";
import { arrayToString } from "../../utils/functions";

export const DisplayCheckErrors: React.FC<{
  name: string;
  subject: string;
  errors: any;
}> = ({ name, subject, errors = {} }) => {
  const errorObj = errors[name];
  const grammarErrors = errorObj?.grammar;
  const similarSubjects = errorObj?.similarSubjects;

  return (
    <Accordion mt={2}>
      {grammarErrors && (
        <AccordionItem border="none" px={0}>
          <AccordionButton px={0}>
            <HStack flex="1" color="red.500" fontSize="sm" textAlign="left">
              <Icon name="error" />
              <Box as="h2">Fix grammar errors</Box>
            </HStack>
            <AccordionIcon />
          </AccordionButton>
          <AccordionPanel fontSize="sm" border="none" px={0}>
            <Stack>
              {Object.entries(grammarErrors).map(
                ([word, errorMessage], idx) => (
                  <Box fontSize="sm" lineHeight="shorter" key={idx}>
                    <Text as="span" fontWeight="semibold">
                      {word}{" "}
                    </Text>
                    - {errorMessage}
                  </Box>
                ),
              )}
            </Stack>
          </AccordionPanel>
        </AccordionItem>
      )}

      {similarSubjects && (
        <AccordionItem border="none" px={0}>
          <AccordionButton px={0}>
            <HStack flex="1" color="red.500" fontSize="sm" textAlign="left">
              <Icon name="error" />
              <Box>Make {name} unique</Box>
            </HStack>
            <AccordionIcon />
          </AccordionButton>
          <AccordionPanel fontSize="sm" px={0} border="none">
            This {name} is too similar to that of{" "}
            {arrayToString(similarSubjects)}. Please make your {name} unique to{" "}
            {subject}.
          </AccordionPanel>
        </AccordionItem>
      )}
    </Accordion>
  );
};
